import { PageBeanContextualConfiguration, PageBeanCustomFieldContext } from '@appsvio/jira-rest-api-client';
import { invoke } from '@forge/bridge';

import fieldForgeApi from '../bridge/fieldForgeApi';
import { ViewContext } from '../interfaces';
import { getIssueTypeIdFromTypeId } from '../utils/utils';

export const fetchCustomfieldConfigurationContextId = async (context: ViewContext) => {
    const fieldId = context.extension.fieldId;
    const projectId = context.extension.project.id.toString();
    const issueTypeId = getIssueTypeIdFromTypeId(context.extension.issue.typeId);
    const fieldConfiguration = await fieldForgeApi.getFieldConfiguration(fieldId, projectId, issueTypeId);
    return fieldConfiguration.id;
};

export const getCustomFieldConfigurationId = async (fieldId: string) => {
    const contexts = await invoke<PageBeanCustomFieldContext>('get-custom-field-global-context', { fieldId });
    if (contexts.values && contexts.values.length) {
        const globalContext = contexts.values[0];
        const configurations = await invoke<PageBeanContextualConfiguration>('get-custom-field-configuration', {
            fieldId,
            fieldContextId: new Set([parseInt(globalContext.id)]),
        });
        const configuration =
            configurations.values ?
                configurations.values.find(configuration => configuration.fieldContextId == globalContext?.id)
            :   undefined;
        return configuration?.id;
    }
};
